import React, { Fragment, useEffect, useState } from 'react';
import { nameMasking, transFormatDate } from '../../util/scripts';
import styled from 'styled-components';
import { useAddPostComment, useDeletePostComment, usePostDelete, usePostsComment } from '../../hooks/RQuery/utils/posts';
import { useRecoilState } from 'recoil';
import { confirmState } from '../../store/Atoms';
import Comment from '../organisms/Comment';
import { log } from 'node:util';

export const BoardCardSt = {
  Card: styled.div`
    width: 100%;
    border-radius: 18px;
    background: #fff;
    box-shadow: 2px 2px 34px 0px #0000000d;
    a {
      text-decoration: underline;
    }
  `,
  CardInner: styled.div`
    padding: 20px;
  `,
  CardTitle: styled.strong`
    display: block;
    line-height: 24px;
    font-size: 16px;
    color: #192640;
    font-weight: 700;
    padding-bottom: 16px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 16px;
    box-sizing: border-box;
  `,
  CardDesc: styled.pre`
    font-size: 14px;
    font-weight: 500;
    color: #091219;
    line-height: 21px;
    margin-bottom: 24px;
  `,
  CardFoot: styled.div`
    padding-top: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #dddddd;
    color: #7c868f;
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
    span,
    button {
      font-weight: 500;
      color: #7c868f;
      font-size: 14px;
    }
    button {
      display: inline-flex;
      align-items: center;
      margin-left: 8px;
      &:before {
        margin-right: 8px;
        content: '';
        width: 1px;
        height: 10px;
        background: #e2e5ea;
      }
    }
  `,
};
const BoardCard = ({ postData, category, onCommentView }) => {
  const [confirm, setConfirm] = useRecoilState(confirmState);
  const [comment, setComment] = useState('');
  const [commentArray, setCommentArray] = useState([]);
  const memberId = sessionStorage.getItem('memberId')!;
  //댓글 목록 api
  const commentList = usePostsComment({ postId: postData.postId, isView: postData.isCommentView });

  //댓글 추가 api
  const addComment = useAddPostComment({ category, memberId, postId: postData.postId });

  //댓글 삭제 api
  const deleteComment = useDeletePostComment({ category, postId: postData.postId });

  useEffect(() => {
    if (commentList.data) {
      setCommentArray(commentList.data);
    }
  }, [commentList.data]);

  //댓글 추가
  const onAddComment = (postId) => {
    addComment.mutate(
      { comment },
      {
        onSuccess: (res: any) => {
          setConfirm({ ...confirm, text: res.message, submitFunc: () => setConfirm({ ...confirm, text: '' }) });
        },
      },
    );
  };

  //게시글 삭제 api
  const deletePost = usePostDelete({ category });

  //게시글 삭제
  const onDeletePost = (postId) => {
    // Confirm 상태 업데이트를 먼저 실행
    setConfirm({
      ...confirm,
      text: '게시글을 삭제하시겠습니까?',
      submitFunc: () => {
        setConfirm({ ...confirm, text: '' });
        deletePost.mutate({ postId });
      },
      cancelFunc: () => {
        setConfirm({ ...confirm, text: '' });
      },
    });
  };
  //댓글 삭제
  const onDeleteComment = (commentId) => {
    setConfirm({
      ...confirm,
      text: '댓글을 삭제하시겠습니까?',
      submitFunc: () => {
        setConfirm({ ...confirm, text: '' });
        deleteComment.mutate({ commentId: commentId, memberId: memberId });
      },
      cancelFunc: () => {
        setConfirm({ ...confirm, text: '' });
      },
    });
  };
  const onChange = (e) => {
    const { value } = e.target;
    setComment(value);
  };
  return (
    <BoardCardSt.Card>
      <BoardCardSt.CardInner>
        <BoardCardSt.CardTitle>{postData.title}</BoardCardSt.CardTitle>
        <BoardCardSt.CardDesc dangerouslySetInnerHTML={{ __html: postData.content }}></BoardCardSt.CardDesc>

        {postData.isCommentView ? (
          <Comment datas={commentArray} onDelete={onDeleteComment} onChange={onChange} onAddComment={() => onAddComment(postData.postId)} />
        ) : (
          <button type={'button'} onClick={() => onCommentView(postData)} style={{ color: '#7c868f', fontSize: 14, textDecoration: 'underline', marginBottom: 14 }}>
            댓글보기
          </button>
        )}

        <BoardCardSt.CardFoot>
          <p>{postData.name}</p>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{transFormatDate(postData.createdDate, '/')}</span>
            {postData.memberId === memberId && (
              <button type={'button'} onClick={() => onDeletePost(postData.postId)}>
                삭제
              </button>
            )}
          </div>
        </BoardCardSt.CardFoot>
      </BoardCardSt.CardInner>
    </BoardCardSt.Card>
  );
};

export default BoardCard;
